export default {
  //授课首页
  SKcourseList:'',
}



// WEBPACK FOOTER //
// ./src/store/give-course/index/states.js